import Header6_2_morph from './Header6_2_morph'
export default Header6_2_morph
